// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  display: flex;
  background-color: #282c34;
  color: white;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}

.sidemenu {
  width: 260px;
  padding: 10px;
  background-color: #171717;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
}

.side-menu-button {
  padding: 12px;
  border: none;
  border-radius: 5px;
  text-align: left;
  transition: ease 0.25s all;
  cursor: pointer;
  border-bottom: 1px solid #333;
}

.side-menu-button:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.side-menu-button span {
  padding-left: 6px;
  padding-right: 12px;
}

.chatbox {
  flex: 1 1;
  background-color: #212121;
  display: flex;
  flex-direction: column;
  position: relative;
}

.chat-log {
  flex: 1 1;
  overflow-y: auto;
  text-align: left;
  padding: 20px;
  background-color: #212121;
}

.chat-input-holder {
  padding: 12px;
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #212121;
}

.chat-input-form {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.chat-input-textarea {
  background-color: #2f2f2f;
  width: 80%;
  border-radius: 26px;
  border: none;
  outline: none;
  margin: 12px;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.25);
  padding: 17px 60px 17px 17px;
  color: white;
  resize: none;
  line-height: 1.5;
}

.textarea-container {
  display: block;
  position: relative;
  width: 100%;
}

.chat-submit-button {
  position: absolute;
  right: 11%;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.25);
  background-color: rgb(135, 135, 135);
  transition: ease 0.25s all;
}

.chat-submit-button:hover {
  background-color: white;
}

.chat-submit-button img {
  width: 20px;
  height: 20px;
}


.chat-message {
  margin-bottom: 10px;
}

.chat-message.chatgpt {
  background-color: #212121;
}

.chat-message-center {
  display: flex;
  padding: 12px;
  padding-left: 24px;
  padding-right: 24px;
  max-width: 640px;
  margin-left: auto;
  margin-right: auto;
}

.avatar {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #10a37f;
  border-radius: 50%;
  border: 1px solid #4a4a4a;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  flex-grow: 0;
}

.avatar.chatgpt {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  border-radius: 50%;
  border: 1px solid #4a4a4a;
  width: 32px;
  height: 32px;
}

.message {
  background-color: #2f2f2f;
  border-radius: 1.5rem; 
  padding: 12px; 
  font-size: 16px; 
  color: white; 
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  max-width: 600px; 
  word-wrap: break-word;
  overflow-wrap: break-word; 
  line-height: 1.5;
  margin-left: 12px;
}

.avatar-img {
  width: 18px;
  height: 18px;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

.header {
  padding: 10px;
  text-align: right;
}

.header-optionLineOne {
  font-size: 12px;
}

.header-optionLineTwo {
  font-size: 15px;
  font-weight: 800;
}

.header-option {
  display: flex;
  flex-direction: column;
  margin-left: 10px;
  margin-right: 10px;
  color: white;
}

a {
  text-decoration: none;
}

.conversations-list {
  flex-grow: 1;
  overflow-y: auto;
  margin-top: 10px;
}

.conversation-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 8px;
  background-color: #171717;
  padding: 8px;
  border: 1px solid 171717;
  border-radius: 5px;
  text-align: left;
  transition: ease 0.25s all;
  color: white;
}

.conversation-item-button {
  width: 100%;
  text-align: left;
}

.conversation-item:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.conversation-item.active {
  background-color: rgba(255, 255, 255, 0.1);
}

.conversation-item span {
  flex-grow: 1;
  color: white;
  text-align: left;
  white-space: nowrap;       
  overflow: hidden;           
  text-overflow: ellipsis;     
}

.conversation-item button {
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  transition: ease 0.25s all;
}

.conversation-item button:hover {
  color: #10a37f;
}

.admin-button {
  margin-top: auto;
  padding-top: 10px;
  border-top: 1px solid #333;
  text-align: center;
}

.admin-button button{
  width: 100%;
  padding: 10px;
  border: none;
  background-color: #10a37f;
  color: white;
  cursor: pointer;
  transition: ease 0.25s all;
  border-radius: 5px;
}

.admin-button button:hover {
  background-color: #0e8f6d;
}

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: transparent;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #252424;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.1);
}`, "",{"version":3,"sources":["webpack://./src/styles/Chat.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,yCAAyC;EACzC,4BAA4B;EAC5B,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yCAAyC;EACzC,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;;AAGA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,wCAAwC;EACxC,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,UAAU;AACV;EACE,UAAU;AACZ;;AAEA,UAAU;AACV;EACE,uBAAuB;AACzB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,oCAAoC;AACtC","sourcesContent":[".App {\n  text-align: center;\n  display: flex;\n  background-color: #282c34;\n  color: white;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n}\n\n.sidemenu {\n  width: 260px;\n  padding: 10px;\n  background-color: #171717;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100vh;\n}\n\n.side-menu-button {\n  padding: 12px;\n  border: none;\n  border-radius: 5px;\n  text-align: left;\n  transition: ease 0.25s all;\n  cursor: pointer;\n  border-bottom: 1px solid #333;\n}\n\n.side-menu-button:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.side-menu-button span {\n  padding-left: 6px;\n  padding-right: 12px;\n}\n\n.chatbox {\n  flex: 1;\n  background-color: #212121;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n\n.chat-log {\n  flex: 1;\n  overflow-y: auto;\n  text-align: left;\n  padding: 20px;\n  background-color: #212121;\n}\n\n.chat-input-holder {\n  padding: 12px;\n  position: sticky;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: #212121;\n}\n\n.chat-input-form {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n\n.chat-input-textarea {\n  background-color: #2f2f2f;\n  width: 80%;\n  border-radius: 26px;\n  border: none;\n  outline: none;\n  margin: 12px;\n  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.25);\n  padding: 17px 60px 17px 17px;\n  color: white;\n  resize: none;\n  line-height: 1.5;\n}\n\n.textarea-container {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n\n.chat-submit-button {\n  position: absolute;\n  right: 11%;\n  top: 50%;\n  transform: translateY(-50%);\n  border: none;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.25);\n  background-color: rgb(135, 135, 135);\n  transition: ease 0.25s all;\n}\n\n.chat-submit-button:hover {\n  background-color: white;\n}\n\n.chat-submit-button img {\n  width: 20px;\n  height: 20px;\n}\n\n\n.chat-message {\n  margin-bottom: 10px;\n}\n\n.chat-message.chatgpt {\n  background-color: #212121;\n}\n\n.chat-message-center {\n  display: flex;\n  padding: 12px;\n  padding-left: 24px;\n  padding-right: 24px;\n  max-width: 640px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.avatar {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #10a37f;\n  border-radius: 50%;\n  border: 1px solid #4a4a4a;\n  width: 32px;\n  height: 32px;\n  flex-shrink: 0;\n  flex-grow: 0;\n}\n\n.avatar.chatgpt {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: white;\n  border-radius: 50%;\n  border: 1px solid #4a4a4a;\n  width: 32px;\n  height: 32px;\n}\n\n.message {\n  background-color: #2f2f2f;\n  border-radius: 1.5rem; \n  padding: 12px; \n  font-size: 16px; \n  color: white; \n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  max-width: 600px; \n  word-wrap: break-word;\n  overflow-wrap: break-word; \n  line-height: 1.5;\n  margin-left: 12px;\n}\n\n.avatar-img {\n  width: 18px;\n  height: 18px;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n.header {\n  padding: 10px;\n  text-align: right;\n}\n\n.header-optionLineOne {\n  font-size: 12px;\n}\n\n.header-optionLineTwo {\n  font-size: 15px;\n  font-weight: 800;\n}\n\n.header-option {\n  display: flex;\n  flex-direction: column;\n  margin-left: 10px;\n  margin-right: 10px;\n  color: white;\n}\n\na {\n  text-decoration: none;\n}\n\n.conversations-list {\n  flex-grow: 1;\n  overflow-y: auto;\n  margin-top: 10px;\n}\n\n.conversation-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  margin-top: 8px;\n  background-color: #171717;\n  padding: 8px;\n  border: 1px solid 171717;\n  border-radius: 5px;\n  text-align: left;\n  transition: ease 0.25s all;\n  color: white;\n}\n\n.conversation-item-button {\n  width: 100%;\n  text-align: left;\n}\n\n.conversation-item:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.conversation-item.active {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.conversation-item span {\n  flex-grow: 1;\n  color: white;\n  text-align: left;\n  white-space: nowrap;       \n  overflow: hidden;           \n  text-overflow: ellipsis;     \n}\n\n.conversation-item button {\n  background: none;\n  border: none;\n  color: white;\n  cursor: pointer;\n  transition: ease 0.25s all;\n}\n\n.conversation-item button:hover {\n  color: #10a37f;\n}\n\n.admin-button {\n  margin-top: auto;\n  padding-top: 10px;\n  border-top: 1px solid #333;\n  text-align: center;\n}\n\n.admin-button button{\n  width: 100%;\n  padding: 10px;\n  border: none;\n  background-color: #10a37f;\n  color: white;\n  cursor: pointer;\n  transition: ease 0.25s all;\n  border-radius: 5px;\n}\n\n.admin-button button:hover {\n  background-color: #0e8f6d;\n}\n\n/* width */\n::-webkit-scrollbar {\n  width: 8px;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: #252424;\n  border-radius: 10px;\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.1);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
